import moment, { Moment } from 'moment';
import React from 'react';
import _ from 'underscore';
import { IScheduleAvailability } from '../../models/Visitation';
import VisitationWindowBlock from './VisitationWindowBlock';

interface IVisitationWindowDayProps {
  day: Moment,
  availability: IScheduleAvailability[],
  startTime: number,
  endTime: number,
  interval: number,
  onBlockSelect(block): void
  selectedBlock: IScheduleAvailability
}

class VisitationWindowDay extends React.Component<IVisitationWindowDayProps> {
  handleBlockSelect(block) {
    this.props.onBlockSelect(block);
  }

  // Calculate the number of time slot increments between the start and end times
  // If this gets changed, update Relcore Central's logic to match
  calculateNumRows(startTime, endTime) {
    return ((endTime - startTime)/this.props.interval) + 1;
  }

  // If this gets changed, update Relcore Central's logic to match
  filterAvailability(currentDay, availability) {
    return availability.filter(a =>
      moment(currentDay).startOf('day').isSame(moment(a.reservationStartDate.date).startOf('day'))
    );
  }

  // If this gets changed, update Relcore Central's logic to match
  groupByTimeOfDay(availability) {
    const interval = this.props.interval;
    return _.groupBy(availability, a => {
      const aDate = moment(a.reservationStartDate.date);
      const minutes = aDate.minute();
      let roundedMinutes: number;

      if (interval === 25) {
        // 15-minute intervals: round to 0, 15, 30, or 45
        roundedMinutes = Math.round(minutes / 15) * 15;
        if (roundedMinutes >= 60) {
          roundedMinutes = 0;
        }
      } else {
        // 30-minute intervals: round to 0 or 30
        roundedMinutes = Math.round(minutes / 30) * 30;
        if (roundedMinutes >= 60) {
          roundedMinutes = 0;
        }
      }

      // Convert rounded minutes to HHMM format (0, 25, 50, or 75 for 15min; 0 or 50 for 30min)
      const minutesInHHMM = Math.floor(roundedMinutes / 60 * 100);
      return parseInt(`${aDate.hour()}${("00" + minutesInHHMM).slice(-2)}`, 10);
    });
  }

  render() {
    const numRows = this.calculateNumRows(this.props.startTime, this.props.endTime);
    const blockAvailability = this.groupByTimeOfDay(
      this.filterAvailability(this.props.day, this.props.availability)
    );

    const buildRow = (time) => {
      const match = blockAvailability[time];

      let boundClick;
      if (match != null && match[0].status == 'available') {
        boundClick = () => this.props.onBlockSelect(match[0]);
      } else {
        boundClick = null;
      }

      return (
        <VisitationWindowBlock
          key={`${this.props.day.day()}_${time}`}
          closed={match == null}
          open={match != null && match[0].status == 'available'}
          time={time}
          selected={match && this.props.selectedBlock == match[0]}
          onClick={boundClick} />
      );
    };

    return (
      <div className="col-lg-3 text-center pt-4">
        <h6>{this.props.day.format('ddd, MMM D')}</h6>
        {Array.from(Array(numRows).keys()).map((time) =>
          buildRow(this.props.startTime+(time*this.props.interval))
        )}
      </div>
    );
  }
}

export default VisitationWindowDay;
